import { borderCssFromProps } from '../borderStyles';
import { boxShadowCss } from '../shadowStyles';
import { normalizeAccordionPanelProps } from './accordionPanelProps';

/**
 * Volet — les trois styles qui composent son cadre, calculés une seule fois
 * pour les deux rendus (accordéon Mantine du site, volet déplié du document).
 *
 * L'arrondi est le point délicat : le cadre est porté par l'enveloppe, mais
 * c'est l'en-tête qui peint le fond, donc lui qui doit suivre les angles — et
 * ses angles bas s'ouvrent quand la réponse est visible.
 *
 * @param {object} props sac de style du volet (partiel toléré)
 * @param {{ opened?: boolean }} [options] réponse visible (toujours vraie au document)
 */
export function accordionPanelStyles(props, { opened = true } = {}) {
  const {
    panelColor, answerBackground, border, shadow,
  } = normalizeAccordionPanelProps(props);
  const frame = {
    ...borderCssFromProps(border),
    ...(boxShadowCss(shadow) ? { boxShadow: boxShadowCss(shadow) } : {}),
  };
  const { borderRadius } = frame;
  const radius = typeof borderRadius === 'number'
    ? `${borderRadius}px`
    : borderRadius;

  return {
    frame,
    header: {
      ...(panelColor ? { backgroundColor: panelColor } : {}),
      borderRadius: opened ? `${radius} ${radius} 0 0` : radius,
    },
    answer: {
      ...(answerBackground ? { backgroundColor: answerBackground } : {}),
      borderRadius: `0 0 ${radius} ${radius}`,
    },
  };
}
